export default "__VITE_ASSET__CVYQvTG7__ 640w, __VITE_ASSET__CSN_1HWI__ 1024w";